import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import { bannerStyles } from "@insite/content-library/Widgets/Basic/Banner";
import { slideshowStyles } from "@insite/content-library/Widgets/Basic/Slideshow";
import { productCarouselStyles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import styled, { css } from "styled-components";

export interface HomeStyles {
    mainContainer?: InjectableCss;
}

productCarouselStyles.mainContainer = {
    css: css`
        margin: 0 auto;
        padding-left: 0;
        padding-right: 0;
    `,
};

productCarouselStyles.carouselSlide = {
    css: css`
        position: relative;
        flex: 0 0 auto;
        padding: 0 10px;
    `,
};

productCarouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        border: #e3e3e3 1px solid;
        background: #fafafa;
        padding: 0;
    `,
};

productCarouselStyles.nextArrowGridItem = {
    width: 1,
    align: "middle",
    css: css`
        justify-content: flex-end;
        position: relative;
        padding: 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
            ])}
    `,
};

productCarouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 5px;
        position: absolute;
        top: 40%;
        background: #ef3742;
        &:hover {
            background: #353432;
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};

productCarouselStyles.prevArrowGridItem = {
    width: 1,
    align: "middle",
    css: css`
        justify-content: flex-start;
        position: relative;
        padding: 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
            ])}
    `,
};

productCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 5px;
        position: absolute;
        top: 40%;
        background: #ef3742;
        &:hover {
            background: #353432;
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};

productCarouselStyles.carouselGridItem = {
    width: 10,
    css: css`
        padding-top: 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 90%;
                    max-width: 90%;
                `,
                css`
                    flex-basis: 90%;
                    max-width: 90%;
                `,
                css`
                    flex-basis: 90%;
                    max-width: 90%;
                `,
                css`
                    flex-basis: 90%;
                    max-width: 90%;
                `,
                css`
                    flex-basis: 98%;
                    max-width: 98%;
                `,
            ])}
    `,
};

slideshowStyles.slideshowWrapper = {
    css: css`
        padding: 0;
        position: relative;
    `,
};

bannerStyles.overlayWrapper = {
    css: css`
        width: 100%;
        height: 100%;
        color: white;
        text-align: center;
        padding: 50px 5% 50px 5%;
        display: flex;
        flex-direction: column;
    `,
};

const styles: HomeStyles = {
    mainContainer: {
        css: css`
            display: inline-block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        // css`
                        //    padding-top: 110px;
                        // `,
                        // css`
                        //     padding-top: 110px;
                        // `,
                        // css`
                        //     padding-top: 110px;
                        // `,
                    ],
                    // "max",
                )}

            > div > div[class^="GridWrapper"] {
                max-width: 100%;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin-left: auto;
                    margin-right: auto;
                    > div[class^="GridItemStyle"] {
                        max-width: 100%;
                        margin: 0 auto;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        max-width: 100%;
                                    `,
                                ],
                                "max",
                            )}
                    }
                    > div[class^="GridItemStyle"] {
                        &:first-child {
                            margin-top: 17.5px;
                            max-width: 100%;
                            > div {
                                margin: 0 auto;
                                max-width: 1440px;
                                div[class^="GridItemStyle"] {
                                    > div[class^="Wrapper"] {
                                        height: 45vh;
                                        ${({ theme }: { theme: BaseTheme }) =>
                                            breakpointMediaQueries(theme, [
                                                null,
                                                null,
                                                css`
                                                    max-height: 45vh;
                                                `,
                                                null,
                                                null,
                                            ])}
                                        div {
                                            height: 100%;
                                            button {
                                                span[class^="IconWrapper"] {
                                                    background: #fff;
                                                    opacity: 0.8;
                                                    color: ${getColor("text.accent")};
                                                    justify-content: center;
                                                    &:hover {
                                                        background: ${getColor("primary")};
                                                        color: #fff;
                                                    }
                                                    svg {
                                                        width: 20px;
                                                        height: 20px;
                                                    }
                                                }
                                            }
                                            &.is-draggable {
                                                > div {
                                                    > div {
                                                        ${({ theme }: { theme: BaseTheme }) =>
                                                            breakpointMediaQueries(theme, [
                                                                null,
                                                                null,
                                                                css`
                                                                    padding: 0;
                                                                    max-height: 100%;
                                                                    min-height: 100%;
                                                                `,
                                                                null,
                                                                null,
                                                            ])}
                                                        span[class^="TypographyStyle"] {
                                                            background: #fff;
                                                            opacity: 0.8;
                                                            position: absolute;
                                                            bottom: 0;
                                                            padding: 30px 10px;
                                                            left: 0;
                                                            width: 100%;
                                                            p[class^="TypographyStyle"] {
                                                                color: ${getColor("text.accent")};
                                                                font-size: 13px;
                                                                width: 65%;
                                                                font-weight: 600;
                                                                margin: 0;
                                                            }
                                                            & + button {
                                                                position: absolute;
                                                                bottom: 30px;
                                                                right: 10px;
                                                                max-width: 25%;
                                                                padding: 0 10px;
                                                                ${({ theme }: { theme: BaseTheme }) =>
                                                                    breakpointMediaQueries(theme, [
                                                                        null,
                                                                        null,
                                                                        null,
                                                                        css`
                                                                            padding: 0 7px;
                                                                        `,
                                                                        null,
                                                                    ])}
                                                                span {
                                                                    font-size: 12px;
                                                                    background: none;
                                                                    position: static;
                                                                    opacity: 1;
                                                                    padding: 0;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    &:first-child {
                                        position: relative;
                                        h1 {
                                            text-transform: uppercase;
                                            font-size: 31px;
                                            font-weight: normal;
                                            width: 63%;
                                            border-bottom: 1px solid #fff;
                                            line-height: 42px;
                                            ${({ theme }: { theme: BaseTheme }) =>
                                                breakpointMediaQueries(theme, [
                                                    css`
                                                        width: 85%;
                                                        font-size: 25px;
                                                        line-height: 35px;
                                                    `,
                                                    css`
                                                        width: 85%;
                                                        font-size: 25px;
                                                        line-height: 35px;
                                                    `,
                                                    css`
                                                        font-size: 25px;
                                                        line-height: 35px;
                                                    `,
                                                    css`
                                                        width: 80%;
                                                    `,
                                                    null,
                                                ])}
                                        }
                                        h4 {
                                            text-transform: uppercase;
                                            font-size: 18px;
                                            font-weight: 500;
                                            width: 53%;
                                            ${({ theme }: { theme: BaseTheme }) =>
                                                breakpointMediaQueries(theme, [
                                                    css`
                                                        font-size: 12px;
                                                    `,
                                                    css`
                                                        font-size: 14px;
                                                    `,
                                                    css`
                                                        font-size: 14px;
                                                    `,
                                                    null,
                                                    null,
                                                ])}
                                        }
                                        button[class^="ButtonWrapper"] {
                                            position: absolute;
                                            bottom: 50px;
                                            right: 40px;
                                            ${({ theme }: { theme: BaseTheme }) =>
                                                breakpointMediaQueries(theme, [
                                                    css`
                                                        bottom: 25px;
                                                        right: 25px;
                                                    `,
                                                    css`
                                                        bottom: 25px;
                                                        right: 25px;
                                                    `,
                                                    css`
                                                        bottom: 25px;
                                                        right: 25px;
                                                    `,
                                                    null,
                                                    null,
                                                ])}
                                            span {
                                                font-size: 12px;
                                            }
                                        }
                                    }
                                    &:last-child {
                                        > div {
                                            background: #efefef;
                                            h2 {
                                                display: block;
                                                font-size: 16px;
                                                color: #fff;
                                                background: #193166;
                                                padding: 10px;
                                                font-weight: 500;
                                            }
                                        }
                                        div[data-test-selector="productCarousel_crossSells"] {
                                            > div[class^="GridOffset"] {
                                                > div {
                                                    display: none;
                                                    &:nth-child(2) {
                                                        display: flex;
                                                        padding: 0;
                                                        width: 100%;
                                                        max-width: 100%;
                                                        flex-basis: 100%;
                                                        div[data-test-selector="slides"] {
                                                            flex-direction: column;
                                                            overflow-y: auto;
                                                            max-height: 390px;
                                                            ${({ theme }: { theme: BaseTheme }) =>
                                                                breakpointMediaQueries(theme, [
                                                                    null,
                                                                    null,
                                                                    css`
                                                                        max-height: 320px;
                                                                    `,
                                                                    null,
                                                                    null,
                                                                ])}
                                                            >div {
                                                                height: auto;
                                                                max-height: 130px;
                                                                width: 100% !important;
                                                                left: 0 !important;
                                                                position: relative;
                                                                padding: 10px 20px;
                                                                ${({ theme }: { theme: BaseTheme }) =>
                                                                    breakpointMediaQueries(theme, [
                                                                        css`
                                                                            height: 100% !important;
                                                                        `,
                                                                        css`
                                                                            height: 100% !important;
                                                                        `,
                                                                        css`
                                                                            height: 100% !important;
                                                                        `,
                                                                        css`
                                                                            height: 100% !important;
                                                                        `,
                                                                        null,
                                                                    ])}
                                                                div[data-test-selector="productContainer"] {
                                                                    background: none;
                                                                    border: none;
                                                                    border-bottom: #e3e3e3 1px solid;
                                                                    display: flex;
                                                                    flex-direction: row;
                                                                    padding: 10px 0;
                                                                    a[data-test-selector="productImage"] {
                                                                        width: 30%;
                                                                        > div {
                                                                            background: #fff;
                                                                            img {
                                                                                width: auto;
                                                                                max-width: 100%;
                                                                            }
                                                                        }
                                                                    }
                                                                    a[data-test-selector="productDescriptionLink"] {
                                                                        width: 75%;
                                                                        padding-left: 3%;
                                                                        > span[class^="TypographyStyle"] {
                                                                            position: static;
                                                                            background: none;
                                                                            padding: 0;
                                                                        }
                                                                        & + div[class^="GridWrapper"] {
                                                                            flex-shrink: 22;
                                                                            > div[class^="GridOffset"] {
                                                                                > div {
                                                                                    &:first-child {
                                                                                        display: none;
                                                                                    }
                                                                                    button[data-test-selector="addToCartBtn"] {
                                                                                        position: absolute;
                                                                                        left: 0;
                                                                                        bottom: 10px;
                                                                                        max-width: 30%;
                                                                                        height: 30px;
                                                                                        width: 29%;
                                                                                        padding: 0;
                                                                                        span {
                                                                                            font-size: 12px;
                                                                                            position: static;
                                                                                            padding: 0;
                                                                                            background: none;
                                                                                            opacity: 1;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        &:nth-child(2),
                        &:nth-child(4) {
                            padding: 0;
                            > div:first-child {
                                background: #f8f8f8;
                                padding-bottom: 40px;
                            }
                        }
                        &:nth-child(3) {
                            padding: 0;
                            margin-bottom: 30px;
                        }
                        &:last-child {
                            margin-top: 35px;
                            > div {
                                max-width: 1440px;
                                margin: 0 auto;
                                [class^="GridWrapper"] {
                                    max-width: 100%;
                                }
                                div[class^="GridItemStyle"] {
                                    div[class^="Wrapper"] {
                                        height: 100%;
                                        > div {
                                            height: 100%;
                                        }
                                    }
                                }
                            }
                        }
                        div[class^="ContentWrapper"] {
                            h3 {
                                padding: 30px 0;
                                font-family: "HelveticaCondensed";
                                span {
                                    text-transform: uppercase;
                                }
                            }
                        }
                        div[data-test-selector="productCarousel_crossSells"] {
                            > div[class^="GridOffset"] {
                                max-width: 100%;
                                margin: 0 auto;
                            }
                        }
                    }
                }
            }
        `,
    },
};

const HomePage: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <Page data-test-selector="homePage" fullWidth={[true, true, true, true, true]} {...styles.mainContainer}>
        <Zone contentId={id} zoneName="Content" requireRows />
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...StructuredPageData,
                tooltip:
                    "Code entered in this field will be added to the head of the home page. This field only supports JSON-LD data.",
            },
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

export const HomePageContext = "HomePage";
